import { Component } from '@angular/core';
import {Events, NavParams, AlertController} from "ionic-angular";
import { FoodsProvider } from '../../../providers/foods/foods';

/**
 * Generated class for the MenuCustomersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-menu-customers',
  templateUrl: 'menu-customers.html',
})
export class MenuCustomersPage {

  filters = {
    distpach:true,
    inactive_type: "all",
    active_type: "all",
    food : null
  }
  mode : number = 0;

  constructor(
    public events: Events,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public foodServ: FoodsProvider) {
    this.mode = this.navParams.get('mode');
    this.filters = this.navParams.get('filters');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenuCustomersPage');
  }

  updateCustomers(){
    this.foodServ.updateCustomers()
  }

  refresh(){
    this.events.publish('filters_change',this.filters);
  }

  bagTags(){
    const alert2 = this.alertCtrl.create();
    alert2.setTitle('Tamaño etiquetas');

    alert2.addInput({
      type: 'radio',
      label: 'Grandes',
      value: 'big',
      checked: true
    })

    alert2.addInput({
      type: 'radio',
      label: 'Chicas',
      value: 'small'
    });

    alert2.addButton('Cancelar');
    alert2.addButton({
      text: 'Imprimir',
      handler: size => {
        this.foodServ.printBagTags(size);
      }
    })
    alert2.present();

  }

  printTagsCSV(){
    this.foodServ.printTagsCSV()
  }

  printTags(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Ordenar etiquetas por');

    alert.addInput({
      type: 'radio',
      label: 'Código comida',
      value: 'foodCode',
      checked: true
    });

    alert.addInput({
      type: 'radio',
      label: 'Nombre comida',
      value: 'foodName'
    });

    alert.addInput({
      type: 'radio',
      label: 'Ruta',
      value: 'route'
    });

    alert.addInput({
      type: 'radio',
      label: 'Nombre Cliente',
      value: 'name'
    });

    alert.addButton('Cancelar');
    alert.addButton({
      text: 'Siguiente',
      handler: data => {

        const alert2 = this.alertCtrl.create();
        alert2.setTitle('Tamaño etiquetas');

        alert2.addInput({
          type: 'radio',
          label: 'Grandes',
          value: 'big',
          checked: true
        })

        alert2.addInput({
          type: 'radio',
          label: 'Chicas',
          value: 'small'
        });

        alert2.addButton('Cancelar');
        alert2.addButton({
          text: 'Imprimir',
          handler: size => {
            console.log("!!",data, size);
            this.foodServ.printTags(data, size)
          }
        })
        alert2.present();
      }
    });
    alert.present();

  }

  printTagsT(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Ordenar etiquetas por');

    alert.addInput({
      type: 'radio',
      label: 'Código comida',
      value: 'foodCode',
      checked: true
    });

    alert.addInput({
      type: 'radio',
      label: 'Nombre comida',
      value: 'foodName'
    });

    alert.addInput({
      type: 'radio',
      label: 'Ruta',
      value: 'route'
    });

    alert.addInput({
      type: 'radio',
      label: 'Nombre Cliente',
      value: 'name'
    });

    alert.addButton('Cancelar');
    alert.addButton({
      text: 'Imprimir',
      handler: data => {
        this.foodServ.printTagsT(data)
      }
    });
    alert.present();

  }

  printNewTags(){
    this.foodServ.printNewTags();
  }

  exportRestrictions(type){
    if(type === 'pdf'){
      this.foodServ.exportRestrictionsPDF();
    }
    if(type === 'csv'){
      this.foodServ.exportRestrictionsCSV();

    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/days/menu-customers/menu-customers.ts